<template>
  <div class="chart" ref="chartdiv">
  </div>
</template>
<style itemscope>
  .chart{
    width: 100%;
    height: 500px;
  }
</style>
<script>
  import moment from 'moment';
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4plugins_timeline from "@amcharts/amcharts4/plugins/timeline";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import * as am4plugins_bullets from "@amcharts/amcharts4/plugins/bullets";
  import am4themes_animated from "@amcharts/amcharts4/themes/animated";

  am4core.useTheme(am4themes_animated);

  let icon  = "data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgMTkyIDE5MiIgd2lkdGg9IjUxMnB4Ij48cGF0aCBkPSJtOTYgMGE5NiA5NiAwIDEgMCA5NiA5NiA5Ni4xMDkgOTYuMTA5IDAgMCAwIC05Ni05NnptMCAyNGE3Mi4wNjkgNzIuMDY5IDAgMCAxIDY0LjQ3MiA0MGgtMTI4Ljk0NGE3Mi4wNjkgNzIuMDY5IDAgMCAxIDY0LjQ3Mi00MHptLTcwLjYyNiA4NS45ODRjMjUuMDczIDguNTcyIDQ0LjI2OCAzMy40MDggNTEuNCA1NS4zODlhNzIuMjIyIDcyLjIyMiAwIDAgMSAtNTEuNC01NS4zODl6bTcwLjYyNiAxMC4wMTZhMTYgMTYgMCAxIDEgMTYtMTYgMTYgMTYgMCAwIDEgLTE2IDE2em0xOS4yMiA0NS4zNzRjNy4xMzQtMjEuOTc3IDI2LjMzNC00Ni43OTIgNTEuNC01NS4zNjZhNzIuMjIxIDcyLjIyMSAwIDAgMSAtNTEuNCA1NS4zNjZ6IiBmaWxsPSIjMDAwMDAwIi8+PC9zdmc+Cg=="

  export default {
    name: 'Timeline',
    props : {
      data : {
        type : Array,
        required : true
      }
    },
    computed : {
      items(){
        let colorSet = new am4core.ColorSet();
        return this.data.map(item => ({
          ...item,
          category : 'e',
          text : item.route,
          icon : icon,
          color: colorSet.getIndex(15),
        }));
      }
    },
    mounted() {

      let chart = am4core.create(this.$refs.chartdiv, am4plugins_timeline.CurveChart);
      chart.curveContainer.padding(100, 20, 50, 20);
      chart.maskBullets = false;


      let colorSet = new am4core.ColorSet();

      chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm:ss";
      chart.dateFormatter.dateFormat = "HH";

      chart.data = this.items;

      chart.fontSize = 10;
      chart.tooltipContainer.fontSize = 10;

      let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "category";
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.labels.template.paddingRight = 25;
      categoryAxis.renderer.minGridDistance = 10;
      categoryAxis.renderer.innerRadius = 10;
      categoryAxis.renderer.radius = 30;

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());


      dateAxis.renderer.points = getPoints();


      dateAxis.renderer.autoScale = false;
      dateAxis.renderer.autoCenter = false;
      dateAxis.renderer.minGridDistance = 70;
      dateAxis.baseInterval = { count: 5, timeUnit: "minute" };
      dateAxis.renderer.tooltipLocation = 0;
      dateAxis.renderer.line.strokeDasharray = "1,4";
      dateAxis.renderer.line.strokeOpacity = 0.5;
      dateAxis.tooltip.background.fillOpacity = 0.2;
      dateAxis.tooltip.background.cornerRadius = 5;
      dateAxis.tooltip.label.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");
      dateAxis.tooltip.label.paddingTop = 7;
      dateAxis.endLocation = 0;
      dateAxis.startLocation = -0.5;

      dateAxis.min =  moment().startOf('day').subtract(6,'hour').toDate().getTime();
      dateAxis.max =  moment().endOf('day').add(10,'hour').toDate().getTime();

      let labelTemplate = dateAxis.renderer.labels.template;
      labelTemplate.verticalCenter = "middle";
      labelTemplate.fillOpacity = 0.6;
      labelTemplate.background.fill = new am4core.InterfaceColorSet().getFor("background");
      labelTemplate.background.fillOpacity = 1;
      labelTemplate.fill = new am4core.InterfaceColorSet().getFor("text");
      labelTemplate.padding(7, 7, 7, 7);

      let series = chart.series.push(new am4plugins_timeline.CurveColumnSeries());
      series.columns.template.height = am4core.percent(30);

      series.dataFields.openDateX = "start";
      series.dataFields.dateX = "end";
      series.dataFields.categoryY = "category";
      series.baseAxis = categoryAxis;
      series.columns.template.propertyFields.fill = "color"; // get color from data
      series.columns.template.propertyFields.stroke = "color";
      series.columns.template.strokeOpacity = 0;
      series.columns.template.fillOpacity = 0.6;

      let imageBullet1 = series.bullets.push(new am4plugins_bullets.PinBullet());
      imageBullet1.background.radius = 18;
      imageBullet1.locationX = 1;
      imageBullet1.propertyFields.stroke = "color";
      imageBullet1.background.propertyFields.fill = "color";
      imageBullet1.image = new am4core.Image();
      imageBullet1.image.propertyFields.href = "icon";
      imageBullet1.image.scale = 0.7;
      imageBullet1.circle.radius = am4core.percent(100);
      imageBullet1.background.fillOpacity = 0.8;
      imageBullet1.background.strokeOpacity = 0;
      imageBullet1.dy = -2;
      imageBullet1.background.pointerBaseWidth = 10;
      imageBullet1.background.pointerLength = 10
      imageBullet1.tooltipText = "{text}";

      series.tooltip.pointerOrientation = "up";

      imageBullet1.background.adapter.add("pointerAngle", (value, target) => {
        if (target.dataItem) {
          let position = dateAxis.valueToPosition(target.dataItem.openDateX.getTime());
          return dateAxis.renderer.positionToAngle(position);
        }
        return value;
      });

      let hs = imageBullet1.states.create("hover")
      hs.properties.scale = 1.3;
      hs.properties.opacity = 1;

      let textBullet = series.bullets.push(new am4charts.LabelBullet());
      textBullet.label.propertyFields.text = "text";
      textBullet.disabled = true;
      textBullet.propertyFields.disabled = "textDisabled";
      textBullet.label.strokeOpacity = 0;
      textBullet.locationX = 1;
      textBullet.dy = - 100;
      textBullet.label.textAlign = "middle";

      chart.scrollbarX = new am4core.Scrollbar();
      chart.scrollbarX.align = "center"
      chart.scrollbarX.width = am4core.percent(75);
      chart.scrollbarX.parent = chart.curveContainer;
      chart.scrollbarX.height = 300;
      chart.scrollbarX.orientation = "vertical";
      chart.scrollbarX.x = 128;
      chart.scrollbarX.y = -140;
      chart.scrollbarX.isMeasured = false;
      chart.scrollbarX.opacity = 0.5;

      let cursor = new am4plugins_timeline.CurveCursor();
      chart.cursor = cursor;
      cursor.xAxis = dateAxis;
      cursor.yAxis = categoryAxis;
      cursor.lineY.disabled = true;
      cursor.lineX.disabled = true;

      dateAxis.renderer.tooltipLocation2 = 0;
      categoryAxis.cursorTooltipEnabled = false;

      chart.zoomOutButton.disabled = true;

      let previousBullet;

      function getPoints() {

        let points = [{ x: -1300, y: 200 }, { x: 0, y: 200 }];

        let w = 400;
        let h = 400;
        let levelCount = 4;

        let radius = am4core.math.min(w / (levelCount - 1) / 2, h / 2);
        let startX = radius;

        for (var i = 0; i < 25; i++) {
          let angle = 0 + i / 25 * 90;
          let centerPoint = { y: 200 - radius, x: 0 }
          points.push({ y: centerPoint.y + radius * am4core.math.cos(angle), x: centerPoint.x + radius * am4core.math.sin(angle) });
        }


        for (var i = 0; i < levelCount; i++) {

          if (i % 2 != 0) {
            points.push({ y: -h / 2 + radius, x: startX + w / (levelCount - 1) * i })
            points.push({ y: h / 2 - radius, x: startX + w / (levelCount - 1) * i })

            let centerPoint = { y: h / 2 - radius, x: startX + w / (levelCount - 1) * (i + 0.5) }
            if (i < levelCount - 1) {
              for (var k = 0; k < 50; k++) {
                let angle = -90 + k / 50 * 180;
                points.push({ y: centerPoint.y + radius * am4core.math.cos(angle), x: centerPoint.x + radius * am4core.math.sin(angle) });
              }
            }

            if (i == levelCount - 1) {
              points.pop();
              points.push({ y: -radius, x: startX + w / (levelCount - 1) * i })
              let centerPoint = { y: -radius, x: startX + w / (levelCount - 1) * (i + 0.5) }
              for (var k = 0; k < 25; k++) {
                let angle = -90 + k / 25 * 90;
                points.push({ y: centerPoint.y + radius * am4core.math.cos(angle), x: centerPoint.x + radius * am4core.math.sin(angle) });
              }
              points.push({ y: 0, x: 1300 });
            }

          }
          else {
            points.push({ y: h / 2 - radius, x: startX + w / (levelCount - 1) * i })
            points.push({ y: -h / 2 + radius, x: startX + w / (levelCount - 1) * i })
            let centerPoint = { y: -h / 2 + radius, x: startX + w / (levelCount - 1) * (i + 0.5) }
            if (i < levelCount - 1) {
              for (var k = 0; k < 50; k++) {
                let angle = -90 - k / 50 * 180;
                points.push({ y: centerPoint.y + radius * am4core.math.cos(angle), x: centerPoint.x + radius * am4core.math.sin(angle) });
              }
            }
          }
        }

        return points;
      }

      this.chart = chart;
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
      }
    }
  }
</script>
